/**
 * poppet.Flow
 * A Container-view with a dispatch flow.
 * @version 0.8.0
 */
import View from './view';
const Flow = View.extend({

	// ------------------------------------------------
	// Setup
	// ------------------------------------------------

	className: '',
	mainRegion: 'container',

	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------

	onRender: function () {
		this.dispatch();
	},

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	/**
	 * The dispatch function shows the correct view based on the current information flow given.
	 * @void
	 */
	dispatch: function () {
		//no default action
	},

});

export default Flow
	
